import { memo } from 'react';
import { Button, Tooltip } from '@aimsos/ui';

import { Sparkles } from 'lucide-react';

/**
 * The Entity Header's primary action (Ask, CT-5721). `ariaLabel` names it for a
 * screen reader ("Ask about Sandra Torres" behind the visible "Ask"); `tooltip`
 * wraps it in the design system's `Tooltip`, which opens on hover AND focus —
 * never a `title` attribute.
 *
 * @param {object} props
 * @param {{ label: string, onClick: () => void, icon?: import('lucide-react').LucideIcon,
 *   ariaLabel?: string, tooltip?: string }} props.cta
 */
const EntityHeaderPrimaryCta = memo(function EntityHeaderPrimaryCta({ cta }) {
  const button = (
    <Button variant="primary" size="sm" leftIcon={cta.icon ?? Sparkles} onClick={cta.onClick} aria-label={cta.ariaLabel}>
      {cta.label}
    </Button>
  );

  if (!cta.tooltip) return button;

  return (
    <Tooltip content={cta.tooltip} size="compact" position="bottom">
      {button}
    </Tooltip>
  );
});

export default EntityHeaderPrimaryCta;
